// extracted by mini-css-extract-plugin
export var heading = "DogEarHeading-module--heading--2kn6e";